import React, { useState } from "react";
import "../../../styles/login.css";
import { AuthServices } from "../services/AuthServices";
import logo from "../../../assets/IMGS/shophrLogo.PNG";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { useNavigate } from "react-router-dom";

const Login = ({ handleAlreadyPartner }) => {
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [renderResetPassword, setRenderResetPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value.toLowerCase(),
    });
  };

  const handleResetPassword = () => {
    setRenderResetPassword(true);
  };

  const handleBackToLogin = () => {
    setRenderResetPassword(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await AuthServices.loginUser(formData);
      if (!response.success) {
        navigate("/verification");
      }
      localStorage.setItem("data", JSON.stringify(formData));
      localStorage.setItem("type", JSON.stringify("login"));
      navigate("/verification");
    } catch (error) {
      console.error(error);
      setErrorMessage(error?.response?.data?.message || "An error occurred");
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {!renderResetPassword ? (
        <form onSubmit={handleSubmit}>
          <img src={logo} alt="logo" />
          <h2>Welcome back!</h2>
          <div className="login-credentials">
            <label htmlFor="businessEmail">Business Email</label>
            <input
              placeholder="Enter your business email"
              onChange={handleChange}
              required
              autoComplete="username"
              type="email"
              name="businessEmail"
              id="businessEmail"
            />
          </div>

          {errorMessage && (
            <div className="error-message">
              <p>{errorMessage}</p>
            </div>
          )}
          {loading ? (
            <button>Loading...</button>
          ) : (
            <button type="submit">Login</button>
          )}
          <p className="already-a-partner" onClick={handleResetPassword}>
            Reset Password?
          </p>
          <p className="already-a-partner" onClick={handleAlreadyPartner}>
            Become a Shophr Retailer?
          </p>
        </form>
      ) : (
        <ForgotPasswordForm handleBackToLogin={handleBackToLogin} />
      )}
    </div>
  );
};

export default Login;
